import { Component } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';
import { BasePage } from '../base-page';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { dateToString } from 'src/app/helpers/date-time';

@Component({
    selector: 'app-mko-pushes',
    templateUrl: './mko-pushes.component.html',
    styleUrls: ['./mko-pushes.component.scss'],
    standalone: false
})
export class MkoPushesComponent extends BasePage {
  public byAverageSum = false;
  public byDate = false;

  public startDate?: NgbDateStruct;
  public endDate?: NgbDateStruct;

  public model: {
    caption?: string;
    text?: string;
    sendAll: boolean;
    buyDateStart?: string;
    buyDateEnd?: string;
    averageSum?: number;
    lessAverageSum: boolean;
  } = {
      lessAverageSum: false,
      sendAll: true,
    };

  public constructor(private mApiService: ApiService, private mMessageService: MessageService) {
    super();
    this.isBusy = false;
  }

  public send() {
    this.isBusy = true;

    if (this.byDate && this.startDate) {
      this.model.buyDateStart = dateToString(this.startDate);
    } else {
      this.model.buyDateStart = undefined
    }

    if (this.byDate && this.endDate) {
      this.model.buyDateEnd = dateToString(this.endDate);
    } else {
      this.model.buyDateEnd = undefined
    }

    this.mApiService.post('api/admin/push', this.model).subscribe({
      next: () => {
        this.model.averageSum = this.startDate = this.endDate = this.model.text = this.model.caption = undefined;

        this.mMessageService.addMessage({
          text: 'Рассылка создана',
          type: this.mMessageService.types.success
        }, true);

        this.isBusy = false;
      },
      error: () => {
        this.isBusy = false;
      }
    })
  }
}
